export default "__VITE_ASSET__DpnaTzdJ__"